<template>
  <ul class="d-flex justify-content-center flex-wrap m-0 badge-list">
    <li
      v-for="(badge, index) in badgesList"
      :key="index"
      class="list-badge-item flex-center flex-column pointer"
      @click="$emit('select', badge)"
    >
      <div class="list-icon-wrapper flex-center">
        <svg-sprite-icon :id="badge.icon" />
      </div>
      <div class="text-prime text-small mt-1 text-nowrap">{{ badge.caption }}</div>
    </li>
  </ul>
</template>

<script>
import { DEFAULT_BADGES_LIST } from '@/constants/badges'
import SvgSpriteIcon from '@/components/SvgSpriteIcon'

/**
 * This shows the list of badges to choose from while selecting badge for giving an award
 */
export default {
  name: 'BadgesList',
  props: ['selected'],
  components: {
    SvgSpriteIcon
  },
  data() {
    return {
      badgesList: DEFAULT_BADGES_LIST
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.list-badge-item {
  @include dimension(100px, 100px);
  margin-bottom: 15px;
  margin-right: 15px;
  border-radius: 10px;

  &:nth-child(4n) {
    margin-right: 0;
  }

  &:hover .list-icon-wrapper {
    background-color: $activeQuaternary;
  }
}

.list-icon-wrapper {
  @include dimension(65px, 65px);
  background-color: $quinary;
  border-radius: 50%;
}
</style>
